(function () {
  var SLOTS = 4;          // watches in the dropdown
  var RESULT_SLOTS = 24;  // matching watches shown on the results page
  var catalogPromise = null;
  var cardCache = {};
  var pickCache = {};

  function loadCatalog() {
    if (catalogPromise) return catalogPromise;
    catalogPromise = (async function () {
      try {
        var cached = sessionStorage.getItem('lxvi-model-numbers-v3');
        if (cached) return JSON.parse(cached);
      } catch (e) {}
      var root = window.Shopify.routes.root, pageNo = 1, list = [];
      while (pageNo < 12) {
        var res = await fetch(root + 'products.json?limit=250&page=' + pageNo);
        if (!res.ok) break;
        var data = await res.json();
        if (!data.products.length) break;
        data.products.forEach(function (p) {
          var sku = p.variants[0] && p.variants[0].sku;
          if (sku && /^\d{3,4}$/.test(sku)) {
            list.push({ h: p.handle, s: sku, t: (p.title || '').toLowerCase(), a: p.variants.some(function (v) { return v.available; }) });
          }
        });
        pageNo++;
      }
      try { sessionStorage.setItem('lxvi-model-numbers-v3', JSON.stringify(list)); } catch (e) {}
      return list;
    })();
    return catalogPromise;
  }

  function key(card) {
    var a = card.querySelector('a[href*="/products/"]');
    return a ? a.getAttribute('href').split('?')[0] : card.textContent;
  }
  // Groups the two copies of each card (phone + desktop). A watch already added by an
  // earlier call is skipped, so the same watch is never shown twice.
  function group(list, map, order) {
    var fresh = {};
    list.forEach(function (c) {
      var k = key(c);
      if (map[k] && !fresh[k]) return;
      if (!map[k]) { map[k] = []; order.push(k); fresh[k] = true; }
      map[k].push(c);
    });
  }

  // Only watches that match what was typed: the exact model first, then models that start with it,
  // then models that have it somewhere in their title. Nothing "close but different" is added.
  function nearest(list, q, count) {
    var scored = [];
    list.forEach(function (p) {
      var exact = p.s === q;
      var starts = p.s.indexOf(q) === 0;
      var inTitle = !starts && p.t.indexOf(q) > -1;
      if (!exact && !starts && !inTitle) return;
      if (!exact && !p.a) return;
      var len = Math.max(p.s.length, q.length);
      var target = Number(q.padEnd(len, '0').slice(0, len));
      scored.push({ p: p, tier: exact ? 0 : (starts ? 1 : 2), d: Math.abs(Number(p.s) - target) });
    });
    scored.sort(function (a, b) { return (a.tier - b.tier) || (a.d - b.d); });
    return scored.slice(0, count).map(function (x) { return x.p; });
  }

  // ---------- Dropdown ----------
  function cardsFor(p) {
    if (!cardCache[p.h]) {
      cardCache[p.h] = (async function () {
        var url = window.Shopify.routes.root + 'search?q=' + encodeURIComponent('"' + p.s + '"') + '&section_id=predictive-search';
        var html = await (await fetch(url)).text();
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var box = doc.querySelector('.predictive-search__products');
        return box ? Array.from(box.children).filter(function (c) {
          return key(c).split('/').pop() === p.h; // exact handle, not "starts with"
        }) : [];
      })();
      cardCache[p.h].catch(function () { delete cardCache[p.h]; });
    }
    return cardCache[p.h];
  }

  // Start fetching the best watches while the customer is still typing
  function prepare(q) {
    if (!pickCache[q]) {
      pickCache[q] = loadCatalog().then(function (list) {
        return Promise.all(nearest(list, q, SLOTS).map(cardsFor));
      });
      pickCache[q].catch(function () { delete pickCache[q]; });
    }
    return pickCache[q];
  }

  // Load the model-number list only when someone opens the search (not on every page view)
  document.addEventListener('focusin', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('#predictive-search-form input[name="q"]')) loadCatalog();
  }, true);

  document.addEventListener('input', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('#predictive-search-form input[name="q"]')) {
      var q = t.value.trim();
      if (/^\d{2,4}$/.test(q)) prepare(q);
    }
  }, true);

  document.documentElement.addEventListener('theme:loading:end', async function () {
    var input = document.querySelector('#predictive-search-form input[name="q"]');
    var box = document.querySelector('#header-predictive-search .predictive-search__products');
    if (!input || !input.value.trim()) return;
    var q = input.value.trim();

    if (!box) {
      // Shopify found nothing: borrow the normal dropdown layout from the best matching watch
      var slot = document.querySelector('#header-predictive-search [slot="results"]');
      var empty = slot && slot.querySelector('.predictive-search__no-results');
      if (!/^\d{2,4}$/.test(q) || !empty || slot.dataset.lxviSeed === q) return;
      slot.dataset.lxviSeed = q;
      empty.style.visibility = 'hidden';
      try {
        var cands = nearest(await loadCatalog(), q, 5);
        var seedSection = null;
        for (var ci = 0; ci < cands.length && !seedSection; ci++) {
          var seedUrl = window.Shopify.routes.root + 'search?q=' + encodeURIComponent('"' + cands[ci].s + '"') + '&section_id=predictive-search';
          var seedDoc = new DOMParser().parseFromString(await (await fetch(seedUrl)).text(), 'text/html');
          var found = seedDoc.querySelector('.shopify-section');
          if (found && found.querySelector('.predictive-search__products')) seedSection = found;
        }
        if (input.value.trim() !== q || !seedSection) { empty.style.visibility = ''; return; }
        slot.replaceChildren.apply(slot, Array.from(document.importNode(seedSection, true).children));
      } catch (e) { empty.style.visibility = ''; return; }
      box = document.querySelector('#header-predictive-search .predictive-search__products');
      if (!box) return;
    }

    if (box.dataset.lxviDone === q) return;
    box.dataset.lxviDone = q;
    box.style.setProperty('--product-list-items-per-row', SLOTS);

    var numeric = /^\d{2,4}$/.test(q);
    // Hide Shopify's own (less relevant) results until the better ones are ready
    if (numeric) box.style.visibility = 'hidden';

    try {
      if (numeric) {
        var groups = await prepare(q);
        if (input.value.trim() !== q) return;
        var ours = [];
        groups.forEach(function (g) {
          g.forEach(function (c) { ours.push(document.importNode(c, true)); });
        });
        // Watches with the number in their title first, then Shopify's own results
        // (those also match on descriptions), without repeating a watch
        var nmap = {}, norder = [];
        group(ours, nmap, norder);
        group(Array.from(box.children), nmap, norder);
        var merged = [];
        norder.slice(0, SLOTS).forEach(function (k) { merged = merged.concat(nmap[k]); });
        if (merged.length) box.replaceChildren.apply(box, merged);
        return;
      }

      // Text search: keep Shopify's results, fill up to 4, title matches first
      var map = {}, order = [];
      group(Array.from(box.children), map, order);
      if (order.length < SLOTS) {
        var url = window.Shopify.routes.root + 'search?q=' + encodeURIComponent(q) + '&section_id=predictive-search';
        var html = await (await fetch(url)).text();
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var full = doc.querySelector('.predictive-search__products');
        if (input.value.trim() !== q) return;
        if (full) group(Array.from(full.children).map(function (c) { return document.importNode(c, true); }), map, order);
      }
      var needle = q.toLowerCase();
      var best = [], other = [];
      order.forEach(function (k) {
        var text = ' ' + map[k][0].textContent.toLowerCase().replace(/\s+/g, ' ');
        (text.indexOf(' ' + needle) > -1 ? best : other).push(k);
      });
      var out = [];
      best.concat(other).slice(0, SLOTS).forEach(function (k) { out = out.concat(map[k]); });
      box.replaceChildren.apply(box, out);
    } catch (e) {
    } finally {
      box.style.visibility = '';
    }
  });

  // ---------- Results page ----------
  async function rankResultsPage() {
    if (!/\/search\/?$/.test(location.pathname)) return;
    var params = new URLSearchParams(location.search);
    var q = (params.get('q') || '').trim();
    if (!/^\d{2,4}$/.test(q)) return;
    if (Number(params.get('page') || 1) > 1 || params.get('sort_by')) return;
    var hasFilter = false;
    params.forEach(function (v, k) { if (k.indexOf('filter.') === 0) hasFilter = true; });
    if (hasFilter) return;

    var list = document.querySelector('product-list');
    var section = document.querySelector('.shopify-section--main-search');
    if (!section) return;
    var sectionId = section.id.replace('shopify-section-', '');
    var root = window.Shopify.routes.root;

    if (list) list.style.visibility = 'hidden';
    else section.style.visibility = 'hidden';
    try {
      var picks = nearest(await loadCatalog(), q, RESULT_SLOTS);
      if (!picks.length) return; // no matching watch: leave Shopify's own results as they are

      // Shopify found nothing: borrow the normal results layout from a matching watch
      if (!list) {
        var seedSection = null, seedSku = '';
        for (var si = 0; si < picks.length && si < 5 && !seedSection; si++) {
          var seedHtml = await (await fetch(root + 'search?q=' + encodeURIComponent(picks[si].s) + '&section_id=' + encodeURIComponent(sectionId))).text();
          var seedDoc = new DOMParser().parseFromString(seedHtml, 'text/html');
          var found = seedDoc.querySelector('.shopify-section');
          if (found && found.querySelector('product-list')) { seedSection = found; seedSku = picks[si].s; }
        }
        if (!seedSection) return;
        var markup = seedSection.innerHTML;
        if (section.setHTMLUnsafe) section.setHTMLUnsafe(markup); else section.innerHTML = markup;
        list = section.querySelector('product-list');
        if (!list) return;
        list.replaceChildren(); // drop the borrowed results, only our ranked watches are shown
        var title = section.querySelector('.section-header p');
        if (title) title.textContent = title.textContent.split('"' + seedSku + '"').join('"' + q + '"');
      }

      var ranked = await Promise.all(picks.map(async function (p) {
        var html = await (await fetch(root + 'search?q=' + encodeURIComponent(p.s) + '&section_id=' + encodeURIComponent(sectionId))).text();
        var doc = new DOMParser().parseFromString(html, 'text/html');
        return Array.from(doc.querySelectorAll('product-card')).filter(function (c) {
          return c.getAttribute('handle') === p.h;
        })[0];
      }));
      ranked = ranked.filter(Boolean).map(function (c) { return document.importNode(c, true); });
      if (!ranked.length) return;

      // Watches with the number in their title first, then Shopify's own results
      // (those also match on descriptions), without repeating a watch
      var taken = {};
      ranked.forEach(function (c) { taken[c.getAttribute('handle')] = true; });
      var rest = Array.from(list.children).filter(function (c) { return !taken[c.getAttribute('handle')]; });
      list.replaceChildren.apply(list, ranked.concat(rest));
      // The theme's fade-in only runs for cards it loaded itself, so show ours right away
      Array.from(list.children).forEach(function (c) { c.removeAttribute('reveal-on-scroll'); });

      var count = section.querySelector('.section-header p');
      if (count) count.textContent = count.textContent.replace(/\d+/, list.children.length);
    } catch (e) {
    } finally {
      if (list) list.style.visibility = '';
      section.style.visibility = '';
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', rankResultsPage);
  else rankResultsPage();
})();
